"use client";

import React, { useState } from "react";
import { SquaresFour } from "@phosphor-icons/react";

import { RadioGroup, RadioGroupItem } from "@shared/ui/radio-group";
import { RoleTag } from "@shared/ui/tag";

import { WorkspaceSvg, type WorkspaceRole } from "~/assets/svg/workspace";
import { CustomCard } from "~/components/custom-card";
import { Section } from "~/components/section";

const options: WorkspaceRole[] = ["Owner", "Admin", "Standard"];

export const WorkspaceInfo = () => {
  const [value, setValue] = useState<WorkspaceRole>("Owner");
  return (
    <Section title="Scale your DevOps infrastructure with confidence" contentClass="md:grid-cols-1">
      <CustomCard
        Icon={<SquaresFour weight="fill" size={24} />}
        title="Secure team collaboration through smart permissions"
        description="Protect your cloud resources with a thoughtfully designed hierarchy that gives team members exactly the access they need—nothing more, nothing less."
        cardClass="grid grid-cols-1 gap-6 md:grid-cols-2 h-auto gap-0 md:gap-6"
        header={
          <RadioGroup defaultValue="Owner" className="mt-15 gap-11">
            {options.map((option) => (
              <div key={option} className="rounded-xl outline outline-offset-8 outline-white/20">
                <label
                  className="bg-layer-1 has-[button[data-state=checked]]:bg-basic-card-hovered hover:bg-basic-card-hovered has-[button[data-state=checked]]:border-sticker-active flex items-center gap-3 rounded-xl border border-transparent p-4 outline-8 outline-white/[8%] transition-all duration-300 hover:cursor-pointer hover:border"
                  htmlFor={option}
                >
                  <RadioGroupItem
                    value={option}
                    id={option}
                    className="border-sticker-inactive-border data-[state=checked]:border-sticker-active data-[state=checked]:text-sticker-active cursor-pointer"
                    onClick={() => {
                      setValue(option);
                    }}
                  />
                  <RoleTag type={option.toLowerCase() as React.ComponentProps<typeof RoleTag>["type"]}>
                    {option}
                  </RoleTag>
                </label>
              </div>
            ))}
          </RadioGroup>
        }
      >
        <div className="flex h-full items-center justify-center">
          <WorkspaceSvg value={value} />
        </div>
      </CustomCard>
    </Section>
  );
};
